import React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"
import { useReportFormInfo } from "Pages/ReportsAlerts/Reports/@hooks"
import { reportFormData } from "Pages/ReportsAlerts/Reports/@signals"
import { object, string } from "yup"

export default function ReportNameSection() {

	const {
		name,
		setNameInfo,
		error
	} = useReportFormInfo(reportFormData.peek().name, "name", object({ name: string().required("Must provide a report name").trim()
            .min(5, "Name must be at least 5 characters").max(100, "Name cannot exceed 100 characters")}))

	return <TextFieldSeeker
		label="Report Name"
		placeholder="Enter Report Name"
		value={name || ""}
		error={error}
		onChange={e => setNameInfo(e.target.value)}
	/>
}